var EventStream = require('./lib/event_stream');
module.exports = new EventStream();



//////////////////
// WEBPACK FOOTER
// ./~/eventing-bus/index.js
// module id = 491
// module chunks = 0